import { HttpError } from "@refinedev/core";
import axios from "axios";
import Qs from "qs";

const axiosInstance = axios.create({
  params: {
    api_key: process.env.REACT_APP_CP_API_TOKEN,
  },
  paramsSerializer: (params) => {
    return Qs.stringify(params, { arrayFormat: "indices" });
  },
});

axiosInstance.interceptors.request.use((req) => {
  const token = localStorage.getItem("ichigo_admin_token");
  if (token) {
    req.headers = {
      ...req.headers,
      "X-Auth-Token": token,
      "Content-Type": "application/json",
    };
  }
  return req;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let errors = "An error occurred while processing your request";

    // Only extract safe error information from the response
    if (error.response?.data?.error) {
      Object.entries(error.response.data.error).map(([key, errorsArray]) => {
        const _key = key as string;
        const _errorsArray = errorsArray as string[];
        errors = `${key}: ${_errorsArray.join(" | ")}.`;
      });
    } else if (error.response?.data?.errors) {
      errors = error.response.data.errors;
    } else if (error.response?.data?.message) {
      errors = error.response.data.message;
    }

    // Create a clean error object without exposing internal details
    const customError: HttpError = {
      message: errors,
      statusCode: error.response?.status || 500,
      // Only include safe properties, avoid spreading the entire error object
    };

    // Log detailed error information for debugging (server-side only)
    if (process.env.NODE_ENV === "development") {
      console.error("API Error Details:", {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        message: errors,
      });
    }

    return Promise.reject(customError);
  },
);

export default axiosInstance;
